import { Directive, ElementRef, Input, OnInit, OnChanges, Renderer2 } from '@angular/core';

@Directive({ selector: '[mediatag]' })
export class MediaTagDirective implements OnInit {
    @Input("mediatag") item: any;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }
    
    ngOnInit() {
        if (!this.el.nativeElement.classList || !this.item) {
            return
        }

        //this.el.nativeElement.dataset.mediaTag = this.item.text;
        this.renderer.setAttribute(this.el.nativeElement, 'data-mediatag', this.item.text);
        this.renderer.addClass(this.el.nativeElement, `mediatag-${this.item.state}`);
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/mediatag-directive.directive.ts